import { Search } from "components/inputs/Search";
import { InfoMessage } from "../InfoMessage";
import { NicheSection } from "../NicheSection";
import { useSearchNiches } from "./useSearchNiches";
import { useChangeOption } from "./useChangeOption";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";
import { INicheOption } from "../../popups/AddToNichePopup/types";
import "./NicheSelector.scss";

interface INicheSelector {
  nicheFields: INicheOption[];
  suggestNicheFields: INicheOption[];
  myNichesLoading: boolean;
  gifSuggestedNichesLoading: boolean;
  theme?: "light" | "dark";
  isUpload?: boolean;
  onUpdateNiches: (fields: INicheOption[]) => void;
  onFollowNiche: (niche: INicheOption) => void;
}

export const NicheSelector = ({
  nicheFields,
  suggestNicheFields,
  myNichesLoading,
  gifSuggestedNichesLoading,
  theme = "dark",
  isUpload,
  onUpdateNiches,
  onFollowNiche,
}: INicheSelector) => {
  const {
    text,
    handleChange,
    filteredNicheFields,
    filteredSuggestNicheFields,
  } = useSearchNiches({ nicheFields, suggestNicheFields });

  const { handleOptionChange } = useChangeOption({
    nicheFields,
    onUpdateNiches
  });

  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  return (
    <div className={`NicheSelector NicheSelector_is${theme}`}>
      <div className="NicheSearch">
        <Search onChange={handleChange} value={text} theme={theme} size={isDesktop ? "m" : "s"} />
        <InfoMessage>{
          isUpload ?
            "You can only add content to niches that you have joined." :
            "You can only add content to Niches that you follow, in which the content has not been posted before"}
        </InfoMessage>
      </div>
      <NicheSection
        text={text}
        title="YOUR NICHES"
        isEmpty={!nicheFields.length}
        isLoading={myNichesLoading}
        nicheFields={filteredNicheFields}
        onCheckBoxChange={handleOptionChange}
        onFollowNiche={onFollowNiche}
      />
      <NicheSection
        text={text}
        title="SUGGESTED FOR YOU"
        nicheFields={filteredSuggestNicheFields}
        isLoading={gifSuggestedNichesLoading}
        onCheckBoxChange={handleOptionChange}
        onFollowNiche={onFollowNiche}
        isSuggested
      />
    </div>
  );
};
